import {Button} from "reactstrap";
import React, {useEffect, useState} from "react";
import ErrorKeyItemEdit from "./ErrorKeyItemEdit";
import ErrorKeyItemRemove from "./ErrorKeyItemRemove";

interface ErrorKeyItemProps {
    id: number;
    value: string;
    isRemoveMode?: boolean;
}

const ErrorKeyItem: React.FC<ErrorKeyItemProps> = ({id, value, isRemoveMode}) => {
    const [editType, setEditType] = useState<'default' | 'edit' | 'remove'>('default');

    useEffect(() => {
        if (isRemoveMode) setEditType("remove");
        else setEditType("default");
    }, [isRemoveMode]);

    const handleEditClick = () => {
        setEditType('edit');
    }

    const handleCancelSelect = () => {
        setEditType('default');
    }

    if (editType === 'remove')
        return <ErrorKeyItemRemove id={id} value={value}/>

    if (editType === 'edit')
        return <ErrorKeyItemEdit id={id} value={value} onCancel={handleCancelSelect}/>

    return <Button key={id} type="button" onClick={handleEditClick}>{value}</Button>
}

export default ErrorKeyItem